export const emailReg = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;

/**
 * Emailフォームのクライアント側バリデーションを行う関数
 *
 * @example
 * - hoge@example.com : true
 * - yamada.tarou@example.com : true
 * - suzuki.example.com : false（ローカル部分がない（すなわち`@`が存在しない場合）
 * - user..name@example.com : false（ドット文字列を連続で使用する場合）
 * - .username@example.com : false（先頭でドット文字列を使用する場合）
 * - username.@example.com : false（末尾でドット文字列を使用する場合）
 */
export const validateEmail = (email: string) => {
  if (email === "") {
    return { isError: true, errorText: "必須項目を入力してください" };
  }

  if (email.length > 64) {
    return { isError: true, errorText: "メールアドレスは64文字以内で入力してください" };
  }

  if (!emailReg.test(email)) {
    return { isError: !emailReg.test(email), errorText: "メールアドレスを正しく入力してください" };
  }

  return {
    isError: false,
    errorText: "",
  };
};
